<template>
  <el-menu mode="vertical" theme="dark" unique-opened :default-active="$route.path">
    <div :class="{ 'logo-name': sidebar.opened, 'logo-img': !sidebar.opened }">
      <span v-if="sidebar.opened">青柠微影合作商后台系统</span>
      <span v-if="!sidebar.opened">
        <img class="logoImage" src="../../../static/image/logo.png" alt="">
      </span>
    </div>
    <sidebar-item :routes="myRoutes"></sidebar-item>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'   // 获取vuex数据
import SidebarItem from './SidebarItem'
import { agencyQnbarRequest } from '../../utils'
import { number } from 'echarts/lib/export'
export default {
  components: { SidebarItem },
  computed: {
    ...mapGetters([
      'sidebar',
      'permissions'
    ]),
    myRoutes() {
      return this.routes
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  data() {
    return {
      routes: [],
      user_info: {},
      user_all: []
    }
  },
  watch: {
    permissions(newVal) {
      if (newVal && newVal.length > 0) {
        const routes = this.$router.options.routes;
        this.handleRoutes(routes);
      }
    }
  },
  mounted() {
    const routes = this.$router.options.routes;
    const baseInfo = JSON.parse(localStorage.getItem('base_info'));
    if (!baseInfo) {
      const prarm = {}
      agencyQnbarRequest('getdetail', prarm).then(res => {
        console.log(res, '获取数据')
        const baseInfo = res.data
        localStorage.setItem('base_info', JSON.stringify(baseInfo))
        this.handleRoutes(routes)
      })
    } else {
      this.handleRoutes(routes)
    }
  },
  methods: {
    // 处理路由
    handleRoutes(routes_data) {
      // 只从 Vuex 获取权限，不使用 localStorage 缓存
      const user_all = this.permissions && this.permissions.length > 0
        ? this.permissions
        : []
      if (user_all.length === 0) {
        // 权限还未从接口返回，不渲染菜单，等 watch 触发
        this.routes = []
        return
      }

      const mythisroutes = JSON.parse(JSON.stringify(routes_data))
      let newarr = []

      // 辅助鉴权函数：兼容新对象结构与旧字符串结构，并支持超级root权限
      const checkNodePermission = (node) => {
        if (!node.meta) return true;
        const metaVal = typeof node.meta === 'object' ? node.meta.permission : node.meta;
        if (!metaVal) return true;
        return user_all.indexOf(metaVal) !== -1;
      };

      // 第一级菜单过滤
      mythisroutes.forEach(route => {
        if (checkNodePermission(route)) {
          newarr.push(route)
        }
      })

      // 第二级菜单过滤
      newarr.forEach(item => {
        if (item.children) {
          item.children = item.children.filter(child => {
            return checkNodePermission(child)
          })
        }
      })

      // 第三级菜单过滤 (兼容原有 title === '2' 的逻辑)
      newarr.forEach(parent => {
        if (parent.children) {
          parent.children.forEach(child => {
            if (child.children) {
              child.children = child.children.filter(grandChild => {
                return checkNodePermission(grandChild) || grandChild.title === '2'
              })
            }
          })
        }
      })

      this.routes = newarr
      this.$router.options.routes = newarr
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-menu {
  min-height: 100%;
}

.logo-name {
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: center;
  color: #c4d0d9;
}

.logo-img {
  height: 50px;
  width: 100%;
  line-height: 50px;
  text-align: left;
  color: #c4d0d9;
}

.logoImage {
  height: 32px;
  margin-left: 17px;
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Sidebar.vue?1117a18e